export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6b83da1255c831485647dfc5fb473b91.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-600/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <div className="animate-fade-in-up">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Instantly Convert Website Visitors
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
              Into Leads And Customers
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
            Easily communicate with your visitors using our multi-channel engagement software
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href="https://calendly.com/instavisible/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="group px-8 py-4 bg-orange-500 text-white text-lg font-semibold rounded-full hover:bg-orange-600 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-calendar-line mr-2 text-xl"></i>
              Request A Free Demo Today
              <i className="ri-arrow-right-line ml-2 text-xl group-hover:translate-x-1 transition-transform"></i>
            </a>
            
            <a
              href="#features"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border-2 border-white/30 hover:border-white/50 cursor-pointer whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-play-circle-line mr-2 text-xl"></i>
              Learn More
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#features" className="cursor-pointer">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </a>
      </div>
    </section>
  );
}
